<template>
    <v-container>
        <div class="text-left" style="margin-bottom:20px;">
                <router-link to="/archive">
                    <v-btn
                        color="secondary"
                        class="text-right"
                        style="width:250px"
                    >
                        Back
                    </v-btn>
                </router-link>
        </div>            
        <v-row>
            <v-col cols="12">
                <div class="text-left">
                    <p>January 25 Flight</p>
                </div>
                <div class="text-left">
                    <router-link to="/janvegas/sanfrancisco">
                        <v-btn
                            color="primary"
                            class="text-right"
                            style="width:500px"
                        >
                            Sydney to San Francisco United UA830
                        </v-btn>
                    </router-link>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <div class="text-left">
                    <p>January 25</p>
                </div>
                <div class="text-left">
                    <router-link to="/janvegas/vegas25">
                        <v-btn
                            color="primary"
                            class="text-right"
                            style="width:500px"
                        >
                            Las Vegas
                        </v-btn>
                    </router-link>
                </div>
            </v-col>
        </v-row>        

        <v-row>
            <v-col cols="12">
                <div class="text-left">
                    <p>January 26</p>
                </div>
                <div class="text-left">
                    <router-link to="/janvegas/vegas26">
                        <v-btn
                            color="primary"
                            class="text-right"
                            style="width:500px"
                        >
                            Australia Day
                        </v-btn>
                    </router-link>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <div class="text-left">
                    <p>January 27</p>
                </div>
                <div class="text-left">
                    <router-link to="/janvegas/vegas27">
                        <v-btn
                            color="primary"
                            class="text-right"
                            style="width:500px"
                        >
                            January 27
                        </v-btn>
                    </router-link>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <div class="text-left">
                    <p>January 28</p>
                </div>
                <div class="text-left">
                    <router-link to="/janvegas/vegas28">
                        <v-btn
                            color="primary"
                            class="text-right"
                            style="width:500px"
                        >
                            January 28
                        </v-btn>
                    </router-link>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <div class="text-left">
                    <p>January 29</p>
                </div>
                <div class="text-left">
                    <router-link to="/janvegas/vegas29">
                        <v-btn
                            color="primary"
                            class="text-right"
                            style="width:500px"
                        >
                            January 29
                        </v-btn>
                    </router-link>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <div class="text-left">
                    <p>January 30</p>
                </div>
                <div class="text-left">
                    <router-link to="/janvegas/vegas30">
                        <v-btn
                            color="primary"
                            class="text-right"
                            style="width:500px"
                        >
                            January 30
                        </v-btn>
                    </router-link>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <div class="text-left">
                    <p>January 30 Limo Caesars Palace to Las Vegas Airport 1:30PM</p>
                </div>
            </v-col>         
        </v-row>        

    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>